import "./App.css";
import RouterPath from "./Path/RouterPath";

function App() {
  return (
    <div>
      <RouterPath />
    </div>
  );
}

export default App;
